import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { reportListingApi } from '../ListingPage.duck';

import './ReportListingModal.css';

const ReportListingModal = props => {
  const { reportListing, setreportListing, title } = props;
  const reasonTypes = [
    'Misrepresented item',
    'Sold on another platform',
    'Scammer',
    'Offensive item',
    'Harassment',
    'Replica',
  ];
  const [formData, setFormData] = useState({
    listing_url: window.location.href,
    reason_type: reasonTypes[0],
    reason_desc: '',
    listing_title: title?.props?.values?.title?.props?.children?.join(''),
  });

  const [success, setSuccess] = useState(false);

  const dispatch = useDispatch();
  const handleChange = e => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async () => {    
    reportListingApi(formData).then((response)=>{
      if(response.success){
        setSuccess(true);
      }
    })
  };

  return (
    <div className="report_listing_modal_container">
      <div className="modal_overlay"></div>
      <div className="modal_content">
        <div className="modal_header">
          <h2>Report this Listing</h2>
          <button
            type="button"
            onClick={() => {
              setreportListing(false);
            }}
            className="close_modal_button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-x"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
        {success ? (
          <div className="success_message">
            <div className="success_icon_wrapper">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="m9 12 2 2 4-4" />
              </svg>
            </div>
            <div className="success_text">Reported Successfully</div>
          </div>
        ) : (
          <div className="modal_body">
            <div className="form-control-wrapper">
              <label htmlFor="reason_type">Please select the type of problem</label>
              <select id="reason_type" value={formData.reason_type} onChange={e => handleChange(e)}>
                {reasonTypes?.map((reason, i) => {
                  return (
                    <option key={i} value={reason}>
                      {reason}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="form-control-wrapper">
              <label htmlFor="reason_desc">Please Enter the reason</label>
              <textarea
                id="reason_desc"
                onChange={e => handleChange(e)}
                value={formData?.reason_desc}
              />
            </div>
            <div className="modal_footer">
              <button
                type="button"
                className="submit_button"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportListingModal;
